import React from 'react';
import Stack from '@mui/material/Stack';

export function IconAndCallToAction({ imgSrc, children }) {
  return (
    <Stack alignItems="center" spacing={2} sx={{ textAlign: 'center' }}>
      <img src={imgSrc} style={{ width: '5rem' }} />
      {children}
    </Stack>
  );
}
